export { default } from "./useGetLicenses";
